import Tooltip from '@/components/Tooltip';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const NarrativeValuatorTooltip = ({ children }: Props) => {
  return (
    <Tooltip
      light
      title={
        <div className="max-w-[260px] py-x1 px-x1_5 text-tiny text-center text-p-grey-30">
          {children}
        </div>
      }
    >
      <button className="focus:outline-dashed focus:outline-1 focus:outline-solid focus:outline-offset-[3px] focus:outline-p-blue-100 rounded-x0_5">
        <InformationSolid className="fill-softer" />
      </button>
    </Tooltip>
  );
};
